RivalIQ.apps.LandscapeSettings.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    App.on('before:start', function () {

        const emailSettings = RivalIQ.state.user.get('emailSettings');

        const email = RivalIQ.enums.email;

        const facebookAdsTypes = _.sortBy([
            email.type.facebookAdsUnderPerforming,
            email.type.facebookAdsTopPerformer
        ], function (type) {
            return email.details[type].description;
        });

        // don't need to sort these
        const weeklyUpdateTypes = [
            // weekly updates
            email.type.socialSummary
        ];

        // sort these at the end, since some types should only show up under certain conditions
        let socialAndSEOTypes = [
            email.type.landscapeBreakoutPost,

            email.type.engagementGrowth,
            email.type.audienceGrowth,

            email.type.websiteLanguageChange,
            email.type.socialChange,
            email.type.landscapePresenceChange
        ];

        if (RivalIQ.state.account.get('plan').has_likely_promoted) {
            socialAndSEOTypes = socialAndSEOTypes.concat(email.type.likelyBoostedPost);
        }

        if (RivalIQ.state.account.channelDisplay(RivalIQ.enums.sources.INSTAGRAM)) {
            socialAndSEOTypes = socialAndSEOTypes.concat(email.type.instagramLinkedSiteChange);
        }

        socialAndSEOTypes = _.sortBy(socialAndSEOTypes, function (type) {
            return email.details[type].description;
        });

        let listeningTypes = [];
        if (RivalIQ.state.account.get('plan').has_full_instant_search) {
            listeningTypes = [
                email.type.listeningVolumeChanges
            ];
        }

        // the order here is the order they'll appear in the settings UI
        const allTypes = _.flatten([socialAndSEOTypes, facebookAdsTypes, listeningTypes, weeklyUpdateTypes]);

        const items = [];
        let section = null;
        _.each(allTypes, function (type) {

            const typeDetails = email.details[type];
            const groupDetails = email.groupDetails[type];
            if (RivalIQ.state.account.channelDisplay(typeDetails.sourceMask)) {
                const item = _.extend({
                    enabled: Boolean(emailSettings[type])
                }, typeDetails, groupDetails);

                // if this item has a different section, add a section row
                if (section !== item.section) {
                    section = item.section;
                    items.push(_.extend({
                        isSection: true,
                        section: section
                    }, typeDetails, groupDetails));
                }
                items.push(item);
            }
        });

        data.emailSettings = new Backbone.Collection(items);
    });
});
